import { DateTimePickerRangesAll } from "../config/enums";

const Ranges = DateTimePickerRangesAll as Record<string, number>;

const startOf = (date: Date) => new Date(date.setHours(0, 0, 0, 0));
const endOf = (date: Date) => new Date(date.setHours(23, 59, 59, 999));
const span = (from: Date, to: Date): [Date, Date] => [startOf(from), endOf(to)];

/** Today moved on by days, as the legacy filters did; the time of day is left as it is. */
const fromToday = (days: number) => {
  const date = new Date();

  date.setDate(date.getDate() + days);

  return date;
};

/** The From and To dates a relative range stands for, or null for a range that is not relative. */
export function getDateRangeDateValues(range: number | null | undefined): [Date, Date] | null {
  const today = new Date(new Date().setHours(0, 0, 0, 0));
  const year = today.getFullYear();
  const month = today.getMonth();

  switch (range) {
    case Ranges.Yesterday: {
      const yesterday = fromToday(-1);

      return span(yesterday, new Date(yesterday));
    }
    case Ranges.Today:
      return span(new Date(today), new Date(today));
    case Ranges.Tomorrow: {
      const tomorrow = fromToday(1);

      return span(tomorrow, new Date(tomorrow));
    }
    case Ranges["Next 7 Days"]:
      return [new Date(today), fromToday(7)];
    case Ranges["Last 7 Days"]:
      return [fromToday(-7), endOf(new Date())];
    case Ranges["Next Month"]:
      return span(new Date(year, month + 1, 1), new Date(year, month + 2, 0));
    case Ranges["Last Month"]:
      return span(new Date(year, month - 1, 1), new Date(year, month, 0));
    case Ranges["This Month"]:
      return span(new Date(year, month, 1), new Date(year, month + 1, 0));
    case Ranges["Next Year"]:
      return span(new Date(year + 1, 0, 1), new Date(year + 1, 11, 31));
    case Ranges["Last Year"]:
      return span(new Date(year - 1, 0, 1), new Date(year - 1, 11, 31));
    case Ranges["This Year"]:
      return span(new Date(year, 0, 1), new Date(year, 11, 31));
    default:
      return null;
  }
}
